module.exports = __webpack_public_path__ + "assets/img/favicons/ms-icon-150x150.png";